
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-contact-teaser{
  display:flex;
  color:var(--brand-neutral-gray-800);
  font-family:var(--ff-dmsans);
  font-size:var(--fs-base);
  font-weight:var(--fw-light);
  padding:var(--spacing-2);
  gap:var(--spacing-4);
  align-items:start;
  justify-content:center;
  flex-direction:column;
  flex-wrap:wrap;
}

  @media (min-width: 768px){.se-contact-teaser{
    gap:var(--spacing-8);
    flex-direction:row;
    align-items:center;
    justify-content:start
}
  }

  .se-contact-teaser__image img{
      height:8.75rem !important;
      width:8.75rem !important;
      max-width:unset !important;
      border-radius:50%;
      object-fit:cover;
    }

  .se-contact-teaser__content{
    display:flex;
    flex-direction:column;
    align-items:flex-start;
  }

  @media (min-width: 768px){

  .se-contact-teaser__content{
      width:15.875rem
  }
    }

  .se-contact-teaser__name{
    margin:0;
  }

  .se-contact-teaser__title{
    margin:0;
  }

  .se-contact-teaser__contact-links{
    display:inline-flex;
    flex-wrap:wrap;
    column-gap:var(--spacing-4);
    align-items:center;
  }

  .se-contact-teaser__phone,
  .se-contact-teaser__bonus-link{
    margin:0;
    white-space:nowrap;
    font-weight:var(--fw-bold);
  }

  .se-contact-teaser__email{
    margin:0;
    display:flex;
    align-items:center;
    padding:var(--spacing-1) 0;
  }

  .se-contact-teaser__email se-link:hover{
        transform:scale(1.1);
      }

  .se-contact-teaser .separator{
    font-size:var(--fs-xl);
    font-weight:var(--fw-thin);
    line-height:1;
  }

  .se-contact-teaser__bio{
    margin:0;
    font-weight:var(--fw-bold);
  }
`;